export default __webpack_public_path__ + "static/media/icon_pdf.f030706a.svg";